import React, {createContext, useState} from 'react'
import PropTypes from 'prop-types'

export const AddressFieldsContext = createContext()

export const AddressFieldsProvider = ({children}) => {
    const [showAddressFields, setShowAddressFields] = useState(false)

    return (
        <AddressFieldsContext.Provider value={{showAddressFields, setShowAddressFields}}>
            {children}
        </AddressFieldsContext.Provider>
    )
}

AddressFieldsProvider.propTypes = {
    children: PropTypes.node.isRequired
}
